import { useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import FormButton from "../../Components/Buttons/FormButton";
import InputFiled from "../../Components/FormTag/InputFiled";
import { ALPHANUM_SPACE_REGEX } from "../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { Setting } from "./model/Client.type";

import { useNavigate } from "react-router-dom";
import FormRadioButton from "../../Components/FormTag/FormRadioButton";
import FormToggle from "../../Components/FormTag/FormToggle";

export default function ClientSetting() {
  const navigation = useNavigate();
  const [clientSettingData, setClientSettingData] = useState<Setting>(
    new Setting()
  );
  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const [showPurchaseOrder, setShowPurchaseOrder] = useState(false);
  const [shipmentEmails, setShipmentEmails] = useState(true);
  const [allowPositiveAdjustments, setAllowPositiveAdjustments] =
    useState(false);
  const [isPurchaseOrder, setPurchaseOrder] = useState(true);

  const [unitOfMeasure, setUnitOfMeasure] = useState(true);
  const [collapseStates, setCollapseStates] = useState<boolean[]>([
    true,
    true,
    true,
    true,
  ]);
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
    watch,
  } = useForm<Setting>({
    defaultValues: clientSettingData,
  });
  const saveSetting: SubmitHandler<Setting> = (data) => {
    if (!showPurchaseOrder) {
      setShowErr(true);
      setErrMsg("Please enable Allow Backorder");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else {
      setShowErr(false);
      navigation("/account/client/overview/grid-view");
    }
  };
  const handelCancelBtn = () => {
    navigation("/account/client/overview/grid-view");
  };

  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const handleUnitOfMeasureKeyDown = (e: any) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior (e.g., scrolling)
      handleUnitOfMeasureClick();
    }
  };

  const handleUnitOfMeasureClick = () => {
    setUnitOfMeasure((prevUnitOfMeasure) => !prevUnitOfMeasure);
  };
  return (
    <>
      {/* ASN Field */}
      <div className="my-2 bg-white rounded py-3" id={`asnField`}>
        {isShowErr && (
          <div
            className="alert alert-danger text-center position-fixed alert-on-top"
            role="alert"
          >
            {errMsg}
          </div>
        )}
        <div className="d-flex justify-content-between align-item-center px-3">
          <div className="align-self-center">
            <h6 className="fw-bold mb-0">Inbound Setting</h6>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
              onClick={() => toggleCollapse(0)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {/* Conditional rendering based on collapse state */}
        {collapseStates[0] && (
          <div
            className="border-top mt-3 px-2  accordion-collapse collapse show"
            id={`accordionCollapse`}
          >
            <div className="m-2">
              <div className="col-4 d-flex my-3 justify-content-between align-self-end">
                <div>
                  <span className="fw-bold">ASN Field</span>
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-6 col-md-6 col-sm-12 mapping-grid">
                  <div>
                    <label className="fw-medium">Reference 1</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={1}
                    name="ASNFieldReference1"
                    errors={errors.ASNFieldReference1}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 1"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div>
                    <label className="fw-medium">Reference 2</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={2}
                    name="ASNFieldReference2"
                    errors={errors.ASNFieldReference2}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 2"
                  />
                </div>
              </div>
              {showPurchaseOrder ? (
                <div className="col-4 d-flex px-2 pb-1 my-3 justify-content-between align-self-end">
                  <div>
                    <label className="fw-medium">Purchase order</label>
                  </div>
                  <div className="d-flex justify-content-start mt-1">
                    <div>
                      <span
                        onClick={() => {
                          isPurchaseOrder === true
                            ? setPurchaseOrder(false)
                            : setPurchaseOrder(true);
                        }}
                      >
                        <FormToggle
                          defaultChecked={true}
                          tabIndex={8}
                          register={register}
                          name="purchaseOrder"
                        />
                      </span>
                    </div>
                    <div className="fw-medium"> {isPurchaseOrder === true ? "Yes" : "No"}</div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Outbound Field */}

      <div className="my-2 bg-white rounded py-3" id={`outboundField`}>
        <div className="d-flex justify-content-between align-item-center px-3">
          <div className="align-self-center">
            <h6 className="fw-bold mb-0">Outbound Field</h6>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
              onClick={() => toggleCollapse(1)}
            >
              {collapseStates[1] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {/* Conditional rendering based on collapse state */}
        {collapseStates[1] && (
          <div
            className="border-top mt-3 px-2 accordion-collapse collapse show"
            id={`accordionCollapse`}
          >
            <div className="m-2">
              <div className=" row my-3">
                <div className="col-lg-6 col-md-6 col-sm-12 mapping-grid">
                  <div>
                    <label className="fw-medium">Reference 1</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={3}
                    name="OutboundFieldReference1"
                    errors={errors.OutboundFieldReference1}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 1"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div>
                    <label className="fw-medium">Reference 2</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={4}
                    name="OutboundFieldReference2"
                    errors={errors.OutboundFieldReference2}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 2"
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-6 col-md-6 col-sm-12 mapping-grid">
                  <div>
                    <label className="fw-medium">Reference 3</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={5}
                    name="OutboundFieldReference3"
                    errors={errors.OutboundFieldReference3}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 3"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div>
                    <label className="fw-medium">Reference 4</label>
                  </div>
                  <InputFiled
                    type="text"
                    register={register}
                    tabIndex={6}
                    name="OutboundFieldReference4"
                    errors={errors.OutboundFieldReference4}
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                    className="form-control mt-1"
                    placeholder="Enter Alias for Reference - 4"
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-6 d-flex  pb-1 justify-content-between align-self-end">
                  <div>
                    <label className="fw-medium">Allow Backorder</label>
                  </div>

                  <div className="d-flex justify-content-start">
                    <div>
                      <span
                        onClick={() => {
                          showPurchaseOrder === false
                            ? setShowPurchaseOrder(true)
                            : setShowPurchaseOrder(false);
                        }}
                      >
                        <FormToggle
                          defaultChecked={false}
                          tabIndex={7}
                          register={register}
                          name="allowBackorder"
                        />
                      </span>
                    </div>
                    <div className="fw-medium"> {showPurchaseOrder === false ? "No" : "Yes"}</div>
                  </div>
                </div>
                <div className="col-6 d-flex pb-1 justify-content-between align-self-end">
                  <div>
                    <label className="fw-medium">Shipment Emails</label>
                  </div>
                  <div className="d-flex justify-content-start">
                    <div>
                      <span
                        onClick={() => {
                          shipmentEmails === false
                            ? setShipmentEmails(true)
                            : setShipmentEmails(false);
                        }}
                      >
                        <FormToggle
                          defaultChecked={true}
                          tabIndex={8}
                          register={register}
                          name="shipmentEmails"
                        />
                      </span>
                    </div>
                    <div className="fw-medium"> {shipmentEmails === true ? "Yes" : "No"}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Item Master Setting */}

      <div className="my-2 bg-white rounded py-3" id={`itemMasterSetting`}>
        <div className="d-flex justify-content-between align-item-center px-3">
          <div className="align-self-center">
            <h6 className="fw-bold mb-0">Item Master Setting</h6>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
              onClick={() => toggleCollapse(2)}
            >
              {collapseStates[2] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {/* Conditional rendering based on collapse state */}
        {collapseStates[2] && (
          <div
            className="border-top mt-3 px-2 accordion-collapse collapse show"
            id={`accordionCollapse`}
          >
            <div className="row my-3 m-1">
              <div className="col-4">
                <label className="fw-medium">Unit of Measure</label>
              </div>
              <FormRadioButton
                className="col-2 mt-1 fw-medium"
                radioId="sstRadio1"
                tabIndex={9}
                required={false}
                name="unitOfMeasure"
                register={register}
                errors={errors}
                labelName="Imperial"
                defaultChecked={!Boolean(unitOfMeasure)}
                onClick={handleUnitOfMeasureClick}
                value={true}
                onKeyDown={handleUnitOfMeasureKeyDown}
              />
              <FormRadioButton
                className="col-2 fw-medium"
                radioId="sstRadio2"
                tabIndex={10}
                required={false}
                name="unitOfMeasure"
                register={register}
                errors={errors}
                labelName="Metric"
                defaultChecked={Boolean(unitOfMeasure)}
                onClick={handleUnitOfMeasureClick}
                value={false}
                onKeyDown={handleUnitOfMeasureKeyDown}
              />
            </div>
          </div>
        )}
      </div>

      {/* Inventory Setting */}

      <div className="my-2 bg-white rounded py-3" id={`inventorySetting`}>
        <div className="d-flex justify-content-between align-item-center px-3">
          <div className="align-self-center">
            <h6 className="fw-bold mb-0">Inventory Setting</h6>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
              onClick={() => toggleCollapse(3)}
            >
              {collapseStates[3] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {/* Conditional rendering based on collapse state */}
        {collapseStates[3] && (
          <div
            className="border-top mt-3 px-2  accordion-collapse collapse show"
            id={`accordionCollapse`}
          >
            <div className="row my-3 m-1">
              <div className="col-4">
                <label className="fw-medium">Allow positive adjustments?</label>
              </div>
              <div className="col-4 mx-4">
                <div className="d-flex justify-content-start">
                  <div>
                    <span
                      onClick={() => {
                        allowPositiveAdjustments === false
                          ? setAllowPositiveAdjustments(true)
                          : setAllowPositiveAdjustments(false);
                      }}
                    >
                      <FormToggle
                        defaultChecked={false}
                        tabIndex={11}
                        register={register}
                        name="allowPositiveAdjustments"
                      />
                    </span>
                  </div>
                  <div className="fw-medium"> {allowPositiveAdjustments === true ? "Yes" : "No"}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            className="sph-btn me-4"
            tabIndex={12}
            handleClick={handleSubmit(saveSetting)}
          >
            Submit
          </FormButton>

          <FormButton
            className="sph-btn sph-shift me-4"
            tabIndex={13}
            handleClick={handelCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
